import script from "./PsdsDataList.vue?vue&type=script&setup=true&lang=js"
export * from "./PsdsDataList.vue?vue&type=script&setup=true&lang=js"

import "./PsdsDataList.vue?vue&type=style&index=0&id=770ee3a8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770ee3a8"]])

export default __exports__